import {
  MoneyUtils,
  TMoney,
  TMoneyStringOptions,
  defaultMoney,
} from '@coverflex-tech/hypernova-utils';

interface IProps {
  amount?: TMoney;
  className?: string;
  separator?: string;
  options?: Partial<TMoneyStringOptions>;
}

export const FormattedAmount = ({
  amount,
  className,
  separator = ',',
  options,
}: IProps) => {
  const stringMoney = MoneyUtils.moneyToString(amount || defaultMoney, options);
  const chunks = stringMoney.split(',');

  return (
    <div className={className}>
      {chunks ? (
        <>
          {/* integer part */}
          {chunks[0]}
          {chunks[1] && `${separator}${chunks[1]}`}
          {/* decimal part */}
        </>
      ) : (
        stringMoney
      )}
    </div>
  );
};
